import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import { ReactComponent as PaymentCardIcon } from 'assets/images/payment-card.svg';
import Button from 'components/Buttons/Button';
import { Container as PaymentCardItemContainer } from 'components/Payment/PaymentCardItem/styles';

interface ContainerProps {
  twoColumns?: boolean;
  multipleColumns?: boolean;
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  border: 1px solid ${ColorPalette.HEX.BrightGray};
  background-color: ${({ theme }) => theme.listPreviewCard.white};
  height: fit-content;

  @media ${({ theme }) => theme.device.desktop} {
    max-width: ${({ multipleColumns, twoColumns }) => (!multipleColumns || twoColumns ? 'none' : 'calc(50% - 16px)')};
  }
`;

export const ButtonContainer = styled.div`
  display: flex;

  @media ${({ theme }) => theme.device.desktop} {
    position: sticky;
    bottom: 0;
    margin-top: auto;
  }

  @media ${({ theme }) => theme.device.mobile} {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${({ theme }) => theme.group.whiteGrey};
    margin-top: 16px;
  }
`;

export const StyledButton = styled(Button)`
  height: auto;
  min-height: 55px;
  font-size: 16px;
  line-height: initial;
  padding: 14px;

  @media ${({ theme }) => theme.device.mobile} {
    margin: 0px 16px 32px 16px;
  }
`;

export const BoxContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 0 24px;
  width: 100%;
  border: 1px ${({ theme }) => theme.rule.ruleList.lightGrey};
  border-style: solid none;
  background-color: ${({ theme }) => theme.rule.ruleList.white};

  @media ${({ theme }) => theme.device.desktop} {
    margin-bottom: 16px;
    border: none;
  }
`;

export const ButtonGhost: any = styled.button`
  display: flex;
  background-color: ${({ theme }) => theme.rule.ruleList.white};
  background: none;
  border: none;
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.rule.ruleList.primary};
  padding: 26px 0;
  cursor: pointer;
`;

ButtonGhost.Icon = styled.img`
  margin-right: 8px;
`;

export const CreateCardIcon = styled(PaymentCardIcon)`
  color: ${({ theme }) => theme.primaryBackgroundColor};
  width: 24px;
  height: 24px;
  margin-right: 8px;
`;

export const SubTitle = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.rule.greyLight};
  text-align: center;
  font-weight: normal;
`;

export const Content = styled.div`
  padding: 24px 16px 0;
  margin-bottom: 16px;

  & h3 {
    font-size: 14px;
    color: ${({ theme }) => theme.groupedList.item.textColor};
    font-weight: 600;
  }
  & p {
    font-size: 14px;
    color: ${({ theme }) => theme.groupedList.item.textColor};
    margin-bottom: 8px;
  }

  ${Container} {
    margin-top: 16px;
  }
  p + ${Container} {
    margin-top: 8px;
  }
  h3 + ${Container} {
    margin-top: 0;
  }

  &.others ${PaymentCardItemContainer} {
    margin-bottom: 16px;
  }

  & + & {
    padding-top: 8px;
  }
`;

export const SectionContainer = styled.section`
  display: flex;
  flex-direction: column;
  max-width: 1300px;
  min-height: 100%;

  @media ${({ theme }) => theme.device.mobile} {
    background-color: ${({ theme }) => theme.group.whiteGrey};
    max-width: none;
  }
`;
